// URL Encryption Utility for Security
// Encrypts sensitive IDs in URLs to prevent browser history snooping

const SECRET_KEY = 'jewel-mgmt-2025-secure'; // Should be env variable in production

// Simple Base64 encryption with timestamp
export const encryptId = (id) => {
  try {
    if (!id) return id;
    
    const payload = {
      id: id,
      exp: Date.now() + (24 * 60 * 60 * 1000) // Expires in 24 hours (for better UX with shared links)
    };
    const jsonStr = JSON.stringify(payload);
    const encoded = btoa(jsonStr);
    // Make URL-safe by replacing characters
    return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  } catch (error) {
    console.error('Encryption error:', error);
    return id; // Fallback to original ID
  }
};

export const decryptId = (token) => {
  try {
    if (!token) return null;
    
    // Try to decrypt - if it fails, assume it's a plain ID (backward compatibility)
    try {
      // Restore URL-safe characters
      let base64 = token.replace(/-/g, '+').replace(/_/g, '/');
      // Add padding if needed
      while (base64.length % 4) {
        base64 += '=';
      }
      
      const decoded = atob(base64);
      const payload = JSON.parse(decoded);
      
      // Check if token is expired
      if (payload.exp && Date.now() > payload.exp) {
        console.warn('Token expired, returning plain ID');
        return token; // Return as plain ID if expired
      }
      
      return payload.id;
    } catch (decryptError) {
      // If decryption fails, assume it's a plain ID (backward compatibility)
      return token;
    }
  } catch (error) {
    console.error('Decryption error:', error);
    return token; // Fallback to treating it as plain ID
  }
};

// Generate secure route with encrypted token
export const generateSecureRoute = (basePath, id) => {
  const token = encryptId(id);
  return `${basePath}/view?t=${token}`;
};

// Parse secure route to get ID
export const parseSecureRoute = (searchParams) => {
  const token = searchParams.get('t');
  if (!token) return null;
  return decryptId(token);
};

// Hook for React Router
export const useSecureParam = (searchParams) => {
  return parseSecureRoute(searchParams);
};
